/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { lazy } from "react";
import { Loadable } from "components/Loadable";

const Websites = Loadable(lazy(() => import("sections/website")));
const Website = Loadable(lazy(() => import("sections/website/website")));

const websiteRoutes = [
    {
        path: "websites",
        element: <Websites />,
    },
    {
        path: "website/:websiteGuid",
        element: <Website />,
    },
    {
        path: "website/:websiteGuid/:websiteSection",
        element: <Website />,
    },
    {
        path: "website/:websiteGuid/:websiteSection/:changeItem",
        element: <Website />,
    },
];

export { websiteRoutes };
